:host {
    text-align: left;
}
